(ns practitest.frontend.components2.dashboard.charts.bar
  (:require [practitest.frontend.components2.dashboard.charts.render :as r]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.charts.marks-bar :as marks-bar]
            [practitest.frontend.components2.dashboard.charts.scales :as scales]
            [practitest.frontend.components2.dashboard.transforms.bar :as transforms]
            [practitest.frontend.components2.dashboard.events :as-alias events]
            [re-frame.core :as rf]))

(def ^:private min-bar-width 6)

(defn- min-chart-width
  [{:chart/keys [series categories]} x-scale]
  (let [band (marks-bar/min-band-width (count series) min-bar-width)]
    (js/Math.ceil (scales/band-range-width (count categories) band x-scale))))

(defn base-spec [chart]
  (let [x-scale       {:domain        (:chart/categories chart)
                       :padding-inner 0.2
                       :padding-outer 0.1
                       :inset         {:left 20}}
        toggle-evt    #(rf/dispatch [::events/toggle-legend-item (:chart/id chart) %])
        nav-evt       #(rf/dispatch [::events/navigate chart %])
        palette       (:chart/colors-palette chart)
        series-ids    (:chart/series chart)
        series-labels (:chart/series-labels chart)
        ordered-range (mapv (fn [id] (get palette (series-labels id))) series-ids)
        legend?       (not= :no-legend (:chart/legend-location chart))]
    {:mark      :bar
     :padding   {:top 5 :right 20 :bottom 35 :left 35}
     :min-width (min-chart-width chart x-scale)
     :tooltip   true
     :data      (:chart/data chart)
     :encode    {:x     {:field  :category
                         :type   :nominal
                         :axis   {:label-angle -40
                                  :banded?     true}
                         :labels (:chart/category-labels chart)
                         :scale  x-scale}
                 :y     {:field :value
                         :type  :quantitative
                         :axis  {:tick-min-step 1}}
                 :tooltip {:mode :category-value}
                 :color
                 (cond-> {:field  :group
                          :type   :nominal
                          :labels series-labels
                          :scale  {:domain series-ids
                                   :range  ordered-range}}

                         legend?
                         (assoc :legend {:opacity {:one-of (:chart/inactive-groups chart)}
                                         :offset 60}))}
     :on-legend-click toggle-evt
     :on-bar-click    nav-evt}))

(defmethod p/render! ::chart/bar [chart ctx svg-element]
  (r/render-chart! svg-element (base-spec chart) (:split-targets ctx)))

(defmethod p/split-layout? ::chart/bar [_chart] true)

(defmethod p/transform-data ::chart/bar [chart]
  (transforms/transform chart))
